<template>
  <article>
    <div class="filter mt-20 mb-20">
      <div class="filter__item">
        <div class="filter__name">商品：</div>
        <el-input v-model="filters.commodity" placeholder="" size="mini" class="input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">分类：</div>
        <el-select class="filter__input" size="mini" v-model="filters.category">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in categoryList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
      <router-link class="blue-small-btn ml-auto" :to="{path: '/inboundEdit', query: {ibid: 0}}">新建</router-link>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="600">
      <el-table-column prop="ibid" label="入库ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="inmonth" label="月份" width="" align="center">
      </el-table-column>
      <el-table-column label="项目" width="" align="center">
        <template slot-scope="scope">
          <el-link href="scope.row.link" target="_blank">{{scope.row.project}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="" label="类型" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.category == 0" class="danger-btn">正装</div>
          <div v-if="scope.row.category == 1" class="normal-btn">小样</div>
        </template>
      </el-table-column>
      <el-table-column prop="brand" label="品牌" width="" align="center">
      </el-table-column>
      <el-table-column prop="commodity" label="商品" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="product_date" label="生产日期" width="" align="center">
      </el-table-column>
      <el-table-column prop="effective_date" label="保质期" width="" align="center">
      </el-table-column>
      <el-table-column prop="original_price" label="原价" width="" align="center">
      </el-table-column>
      <el-table-column prop="cost_price" label="成本" width="" align="center">
      </el-table-column>
      <el-table-column prop="agent_price" label="代理价" width="" align="center">
      </el-table-column>
      <el-table-column prop="sale_price" label="售出包邮价" width="" align="center">
      </el-table-column>
      <el-table-column prop="stock" label="总库存" width="" align="center">
      </el-table-column>
      <el-table-column prop="sale_number" label="已出" width="" align="center">
      </el-table-column>
      <el-table-column prop="balance" label="剩余库存" width="" align="center">
      </el-table-column>
      <el-table-column prop="sale_amount" label="销售金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="profit" label="利润" width="" align="center">
      </el-table-column>
      <el-table-column prop="remark" label="备注" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <router-link class="blue-small-btn" :to="{path: '/outboundEdit', query: {ibid: scope.row.ibid}}">入库</router-link>
            <router-link class="blue-small-btn ml-10" :to="{path: '/inboundEdit', query: {ibid: scope.row.ibid}}">编辑</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {inboundLists} from '../../../api/api'
export default {
  name: 'inboundList',
  mixins: [mixinList],
  data () {
    return {
      categoryList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '正装',
          value: 0
        },
        {
          name: '小样',
          value: 1
        }
      ],
      lists: [],
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        commodity: '',
        category: ''
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.commodity !== '') {
        params.commodity = filters.commodity
      }
      if (filters.category !== '') {
        params.category = filters.category
      }
      this.listLoading = true
      inboundLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.notifyError('服务器出错了')
      })
    },
    categoryChange () {
      this.filters.p = 1
      this.getList()
    }
  },
  watch: {
    'filters.category': 'categoryChange'
  },
  mounted () {
    this.getList()
    util.setCookie('createAddetail', '')
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/module/stock/inboundList.vue